"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionOverlay = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SelectionOverlay = function (_a) {
    var isDestructive = _a.isDestructive, isVisible = _a.isVisible, children = _a.children;
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: isVisible, timeout: kaleidoscope_1.AnimationDuration.Medium, classNames: "side-by-side__selection-overlay-" },
        react_1.default.createElement("div", { className: "side-by-side__selection-overlay" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("selection-overlay__background", {
                    "selection-overlay__background--destructive": isDestructive,
                }) }),
            react_1.default.createElement("div", { className: "selection-overlay__text" }, children))));
};
exports.SelectionOverlay = SelectionOverlay;
